<mat-form-field
  class="seds-form-field-fonts"
  [appearance]="appearance"
  [floatLabel]="floatLabelText ? 'always' : 'auto'"
  [attr.type]="_type"
  [ngClass]="{
    'form-field-core': true,
    'mat-form-field-with-warning': warningColor || (color === 'warning' && _type === 'search'),
    'mat-form-field-with-error': (color === 'error' && _type === 'search') || (!warningColor && _type !== 'search'),
  }">
  <mat-label
    class="seds-default-fonts"
    *ngIf="label"
    [class]="warningColor ? 'mat-form-field-with-warning' : 'mat-form-field-with-error'">
    {{ label }}
  </mat-label>
  <input *ngIf="isBeforeViewInit$$ | async" hidden matInput />
  <mat-icon
    tabindex="0"
    role="button"
    aria-hidden="false"
    [attr.aria-label]="iconLabel"
    (click)="handleIconClick()"
    (keydown)="handleIconKeyboardEvent($event)"
    class="seds-align-middle"
    *ngIf="iconPosition === 'left' && iconName !== ''"
    matPrefix>
    {{ iconName }}</mat-icon
  >
  <ng-content></ng-content>
  <mat-icon
    tabindex="0"
    role="button"
    aria-hidden="false"
    [attr.aria-label]="iconLabel"
    (click)="handleIconClick()"
    (keydown)="handleIconKeyboardEvent($event)"
    class="seds-align-middle"
    *ngIf="iconPosition === 'right' && iconName !== ''"
    matSuffix>
    {{ iconName }}</mat-icon
  >
  <mat-icon *ngIf="selectFieldIcon !== ''" class="seds-align-middle" matSuffix>
    {{ selectFieldIcon }}
  </mat-icon>
</mat-form-field>
<mat-hint class="seds-default-fonts" *ngIf="hint"> {{ hint }} </mat-hint>
<mat-error
  class="seds-default-fonts"
  *ngIf="
    (ngControl?.invalid && ngControl?.dirty) ||
    (ngControl?.invalid && ngControl?.touched) ||
    (_type === 'dropdown' && ngControl?.invalid && ngControl?.touched) ||
    (_type === 'datepicker' &&
      isRangeInput &&
      ((startNgControl?.invalid && startNgControl?.touched) || (endNgControl?.invalid && endNgControl?.touched)))
  "
  [class]="['custom-mat-error', warningColor ? 'warning-color' : 'error-color']">
  <p *ngIf="!isRangeInput">
    {{ ngControl?.errors | errorReader }}
  </p>
  <p *ngIf="isRangeInput">
    {{ [startNgControl?.errors, endNgControl?.errors] | errorReader }}
  </p>
</mat-error>
